module.exports = __webpack_public_path__ + "static/media/7H.c8475b53.png";